import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHacksterComponent } from './simple-icons-hackster.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHacksterComponent ],
    exports:      [ SimpleIconsHacksterComponent ],
    bootstrap:    []
})
export class SimpleIconsHacksterModule {}
